import { Title4 } from "@components/Typography";
import { useStyles } from "./styles";
import { ExclusiveLabelProps } from "./types";

export const ExclusiveLabel = ({ style, children }: ExclusiveLabelProps) => {
  const styles = useStyles();

  return <Title4 style={{ ...styles.exclusive, ...style }}>{children}</Title4>;
};
